export default __webpack_public_path__ + "static/media/professor.07de570b.jpg";